<template>
  <div id="blood-pressure-list-container">
    <div class="row">
      <div class="col-sm">
        <select
          class="form-control"
          v-model="store.state.bloodPressureView.selectedSortingOption"
          v-on:change="sort"
        >
          <option
            v-for="sortingOption in store.state.bloodPressureView.sortingOptions"
            v-bind:key="sortingOption"
            v-bind:value="sortingOption"
          >{{ sortingOption }}</option>
        </select>
      </div>
      <div class="col-sm"></div>
    </div>
    <div class="mb-3 hidden-md-up"></div>
    <div>
      <bloodPressure-card
        v-for="measurement in measurements"
        v-bind:key="measurement.id"
        :measurement="measurement"
      />
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import BloodPressureCard from "@/components/BloodPressureCard.vue";

export default {
  name: "BloodPressureList",
  components: {
    BloodPressureCard
  },
  data: function() {
    return {
      store: store,
      measurements: []
    };
  },
  computed: {
    selectedSortingOption: function() {
      return this.store.state.bloodPressureView.selectedSortingOption;
    }
  },
  created: function() {},
  mounted: function() {
    this.updateMeasurementsFromStore();
  },
  methods: {
    updateMeasurementsFromStore() {
      this.measurements = [...store.state.bloodPressureMeasurements];
      this.sort();
    },
    sortOldestFirst: function() {
      this.measurements.sort(this.store.compareByDatetimeOldestFirst);
    },
    sortNewestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByDatetimeOldestFirst(a, b) * -1;
      });
    },
    sortHighestSystolicFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByMeasurementHighestFirst(
          a.systolic,
          b.systolic
        );
      });
    },
    sortLowestSystolicFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return (
          self.store.compareByMeasurementHighestFirst(
            a.systolic,
            b.systolic
          ) * -1
        );
      });
    },
    sortHighestDiastolicFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByMeasurementHighestFirst(
          a.diastolic,
          b.diastolic
        );
      });
    },
    sortLowestDiastolicFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return (
          self.store.compareByMeasurementHighestFirst(
            a.diastolic,
            b.diastolic
          ) * -1
        );
      });
    },
    sort: function() {
      if (this.selectedSortingOption == "Newest first") {
        this.sortNewestFirst();
      } else if (this.selectedSortingOption == "Oldest first") {
        this.sortOldestFirst();
      } else if (this.selectedSortingOption == "Highest systolic pressure first") {
        this.sortHighestSystolicFirst();
      } else if (this.selectedSortingOption == "Lowest systolic pressure first") {
        this.sortLowestSystolicFirst();
      } else if (this.selectedSortingOption == "Highest diastolic pressure first") {
        this.sortHighestDiastolicFirst();
      } else if (this.selectedSortingOption == "Lowest diastolic pressure first") {
        this.sortLowestDiastolicFirst();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#blood-pressure-list-container {
  margin-top: 1rem;
}
</style>
